module.exports = __webpack_public_path__ + "img/doc.22de9380.png";